<template>
  <div>
    <section class="main-content">

        <div class="inner-banner inner-banner-bg">
            <div class="container">
                <div class="articles-box">
                    <figure class="pic articles-pic fitimg mb-0" v-for="(row, index) in pics">
                        <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/slide/'+row.image_path" />
                    </figure>
                </div>
            </div>
        </div>

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title"><span>搜尋結果</span></h3>
                            <div class="articles-items">

                              <form class="form-inline">
                                  <label class="mr-sm-2" for="inlineFormCustomSelect">挑選歌曲</label>

                                  <label class="mr-sm-2" for="inlineFormCustomSelect">語文</label>
                                  <select class="custom-select mb-2 mr-sm-2 mb-sm-0" v-model="chooseLang">
                                      <option value="" selected>全部</option>
                                      <option v-for="option in lang" v-bind:value="option.id">
                                          {{option.title}}
                                      </option>
                                  </select>

                                  <label class="mr-sm-2" for="inlineFormCustomSelect">節奏</label>
                                  <select class="custom-select mb-2 mr-sm-2 mb-sm-0" v-model="chooseTempo">
                                      <option value="" selected>全部</option>
                                      <option v-for="option in tempo" v-bind:value="option.id">
                                          {{option.title}}
                                      </option>
                                  </select>
                                  <!-- <input type="text" class="form-control" v-model="keyword" placeholder="歌曲名稱 / 作者" aria-describedby="basic-addon1"> -->

                              </form>

                              <div class="song-list">
                                <div class="song-item song-mainitem row">
                                    <div class="col-md-4">歌曲</div>
                                    <div class="col-md-4">歌者</div>
                                    <div class="col-xl-3 col-md-2">刊登時間</div>
                                    <div class="col-xl-1 col-md-2"></div>
                                </div>
                                  <div class="song-item row" v-for="(row, index) in songdata">
                                      <div class="col-md-4">{{row.title}}</div>
                                      <div class="col-md-4">{{row.author}}</div>
                                      <div class="col-xl-3 col-md-2">{{row.created_at.substr(0,10)}}</div>
                                      <div class="col-xl-1 col-md-2 text-center">
                                        <router-link class="btn-song-detail" v-bind:to="'/Songs/'+row.id">聆聽去</router-link>
                                      </div>
                                  </div>
                              </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Qs from 'qs'
export default {
  name: 'mainsearch',
  data () {
    return {
      uri: this.$store.getters.getUri,
      keyword: 0,
      songdata: Object,
      tempsongdata: Object,
      chooseLang: '',
      chooseTempo: '',
      pics: Object
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getSongTagLang',
      tempo: 'getSongTagTempo'
    })
  },
  mounted: function () {
    this.keyword = this.$route.params.key
    this.searching()
    let self = this
    this.$http.get(this.uri + 'Home/get_search_page_pic').then(function (res) {
      let data = res.data
      if (data.status === 200) {
        self.pics = data.slide
        console.log('data: ' + self.pics)
        return data.slide
      } else {
        console.log('下載圖片失敗')
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ]),
    searching () {
      let uploadData = Qs.stringify({
        keyword: this.keyword
      })
      let self = this
      // 取得搜尋歌曲
      if (this.keyword !== '') {
        this.$http.post(this.uri + 'Song/get_song_by_keyword', uploadData).then(function (res) {
          let data = res.data
          if (data.status === 200) {
            self.songdata = self.tempsongdata = data.songs
            return data.songs
          } else {
            console.log('下載歌曲失敗')
          }
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        window.alert('請輸入關鍵字再進行搜尋。')
      }
    },
    filterSong () {
      let lang = this.chooseLang
      let tempo = this.chooseTempo
      this.songdata = this.tempsongdata
      if (lang !== '') {
        this.songdata = this.songdata.filter(function (value) {
          console.log(value)
          return value.tag_1.indexOf(lang) >= 0
        })
      }
      if (tempo !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_3.indexOf(tempo) >= 0
        })
      }
      if (this.songdata.length < 1) {
        window.alert('尚無歌曲')
      }
      // console.log('filter' + tempo)
    }
  },
  watch: {
    chooseLang: {
      handler: function (val, oldVal) {
        this.filterSong()
      }
    },
    chooseTempo: {
      handler: function (val, oldVal) {
        this.filterSong()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MainSearch.vue?090b3629